import React, { useState } from 'react';
import { AskRequestStatus } from '@hone-automation/common';
import { MobileSlideUpPanel } from 'presentation/components/Mobile/MobileSlideUpPanel/MobileSlideUpPanel';
import { IconCheck, IconClose } from 'components/Icons';
import { useMarkAsSolved } from 'hooks/useMarkAsSolved';
import './Panels.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  txId: string;
  locationId: string;
  activeTab: AskRequestStatus;
  titleIcon?: React.ReactNode;
};

const MobileMarkAsSolvedPanel: React.FC<Props> = ({ isOpen, onClose, txId, locationId, activeTab, titleIcon }) => {
  const [comment, setComment] = useState<string>('');
  const { isPending, markAsSolved } = useMarkAsSolved(txId, locationId, activeTab);

  const handleSubmit = () => {
    markAsSolved({ comment });
    // Reset form
    setComment('');
    onClose();
  };

  const handleCancel = () => {
    // Reset form
    setComment('');
    onClose();
  };

  return (
    <MobileSlideUpPanel
      isOpen={isOpen}
      onClose={handleCancel}
      title="Mark as Solved"
      titleIcon={titleIcon}
      showExplicitCloseButton={false}
    >
      <div className="mobile-form-panel">
        <div className="form-group">
          <label>Closing Comment</label>
          <textarea
            value={comment}
            onChange={e => setComment(e.target.value)}
            placeholder="Add a closing comment (optional)."
            rows={3}
            className="form-textarea"
          />
        </div>
        <div className="form-actions">
          <button className="form-button cancel-button" onClick={handleCancel} disabled={isPending}>
            Cancel
          </button>
          <button className="form-button submit-button" onClick={handleSubmit} disabled={isPending}>
            {isPending ? (
              <>
                Loading... <i className="fa fa-circle-o-notch fa-spin" />
              </>
            ) : (
              <>Mark as Solved</>
            )}
          </button>
        </div>
      </div>
    </MobileSlideUpPanel>
  );
};

export default MobileMarkAsSolvedPanel;
